<script>
  import HelpSection from "./HelpSection.svelte";

</script>


    <HelpSection title="Welcome" big>
    Timer.today will help you log your activity and measure it's duration.
    Simply enter what you are doing currently and press ENTER.
    </HelpSection>


        <HelpSection title="Hashtags">
            You can use #hashtag if you want to categorize items.<br>
            Eg. "Discuss project with John #meeting".
            Only one hashtag per line is allowed. Also hashtags should be a single word.
        </HelpSection>

        <HelpSection title="End Time">
            Clicking "Set end time" would allow you to specify end of day. <br>
            This will allow the app to measure how far in the day you are, based on your earliest entry.
        </HelpSection>

        <HelpSection title="Tag Graph">
            Tag Graph button will show a pie chart of your hashtags (if any)
        </HelpSection>

        <HelpSection title="Notes">
            At the bottom right of your screen you have "Notes" button. Clicking it will expand a text area which allows you to take quick notes - eg TODO for the day, etc.
        </HelpSection>

        <HelpSection title="Generate Summary">
            Once you've entered some items you will notice a button called "Generate summary"
            Clicking it will create a text friendly report in the Notes section.
            The report can be used to share a human readable version with others, or keep for your own records
        </HelpSection>

        <HelpSection title="Changing time">
            &#128337; on each row allows you to change the time for each entry. <br>
            By default each entry is logged with current time, however sometimes you might need to adjust that.
            One example is if you forgot to log something and want to add it to the list between other items.<br>
            Please note that you can not have two entries with the same time.
        </HelpSection>
        <HelpSection title="Editing text">
            You can click on each entry text and edit it after it's creation.
        </HelpSection>

        <HelpSection title="Clear all">
           "Clear all" allows you to bulk remove all your entries.<br>
           This is useful at the start of your day when you want to remove all previous day entries.
        </HelpSection>
